export const ADD_TO_CART = "ADD_TO_CART";
export const SIGN_IN = "SIGN_IN";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const SET_SC_WIDTH = "SET_SC_WIDTH";
export const SET_SC_HEIGHT = "SET_SC_HEIGHT";
export const INCREASE_PRODUCT_COUNT = "INCREASE_PRODUCT_COUNT";
export const DECREASE_PRODUCT_COUNT = "DECREASE_PRODUCT_COUNT";
